import * as z from 'zod'
import { dateSchema, promoCodeDetailsSchema } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const schema = z.object({
  code: z.string(),
  details: promoCodeDetailsSchema.optional().nullable(),
  description: z.string().optional(),
  title: z.string().optional(),
  usageLeft: z.number(),
  expiredAt: dateSchema.nullable(),
  valid: z.boolean(),
})

export type PromoCodeAttributes = z.infer<typeof schema>

export class PromoCode extends ApiModel<typeof schema> {
  static jsonApiType = 'promocodes'

  static schema = schema

  getCode(): string {
    return this.getAttribute('code')
  }

  static async check(code: string): Promise<PromoCodeAttributes> {
    const url = `${PromoCode.getJsonApiUrl()}/check`
    const client = PromoCode.httpClient.getImplementingClient()
    const response = await client.post(url, {
      code,
    })
    return response?.data
  }

  static async validatePromocodeForDriver(
    code: string,
    driverId: string,
    carId: string,
  ) {
    const url = `${PromoCode.getJsonApiUrl()}/validate-promocode`
    const client = PromoCode.httpClient.getImplementingClient()
    const response = await client.post(url, {
      code,
      driverId,
      carId,
    })
    return response?.data
  }
}
